/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./appicon.vue?vue&type=template&id=e52207ae&"
import script from "./appicon.vue?vue&type=script&lang=js&"
export * from "./appicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports